<div class="stream-tab-container">
  <div class="header-text">
    <div class="stream-name">
      <a
        [matTooltip]="getMaxStreamTooltip()"
        (click)="addStream()"
        class="add-stream"
        [ngClass]="
          isValidCloneActionA2B && isValidCloneActionB2A ? 'add-stream-disable' : 'add-stream'
        "
        ><i class="mdi mdi-plus-thick"></i> Add stream</a
      >
    </div>
  </div>
  <div *ngIf="direction !== 'unidirectional-b2a'">
    <div class="direction-label">
      A (Source) <i class="mdi mdi-arrow-right-bold onewayAColor"></i> B (Destination)
    </div>
    <div class="mat-elevation-z8">
      <mat-table #table [dataSource]="dataSourceA2B" multiTemplateDataRows="true" class="table">
        <ng-container matColumnDef="streamName">
          <mat-header-cell *matHeaderCellDef class="header-label"> Name </mat-header-cell>
          <mat-cell *matCellDef="let element; let i = dataIndex" class="name-cell">
            <div class="first-row">
              <input
                matInput
                autocomplete="off"
                type="text"
                name="streamName"
                class="width-115"
                [(ngModel)]="element.streamName"
                [ngClass]="{
                  'error-msg': checkValidation('name', element.streamName, element, 'tableA')
                    ?.isValid
                }"
                (ngModelChange)="
                  checkValidation('name', element.streamName, element, 'tableA');
                  onDataChange(element.streamName, i, configMapping.STREAM_NAME, 'tableA')
                "
                [matTooltip]="
                  checkValidation('name', element.streamName, element, 'tableA')?.message
                "
              />
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="streamType">
          <mat-header-cell *matHeaderCellDef class="header-label"> Stream Type </mat-header-cell>
          <mat-cell *matCellDef="let element; let i = dataIndex">
            <div class="first-row">{{ element.streamType }}</div>
            <a class="edit-text" (click)="onChangeStreamType(element, i, 'tableA')">edit</a>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="streamL2IrA2B">
          <mat-header-cell *matHeaderCellDef class="header-label">
            {{ streamRateConvention === 'l1-mbps' ? 'L1' : 'L2' }} IR
            <div>(A <i class="mdi mdi-arrow-right-bold"></i> B)</div>
            <div class="sub-label">Mbps</div></mat-header-cell
          >
          <mat-cell *matCellDef="let element; let i = dataIndex">
            <div class="first-row">{{ element.streamL2IrA2B }}</div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="streamUdpBwA2B">
          <mat-header-cell *matHeaderCellDef class="header-label">
            UDP BW
            <div>(A <i class="mdi mdi-arrow-right-bold"></i> B)</div>
            <div class="sub-label">Mbps</div></mat-header-cell
          >
          <mat-cell *matCellDef="let element; let i = dataIndex">
            <div class="first-row">{{ element.streamUdpBwA2B }}</div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="streamFrameSize">
          <mat-header-cell *matHeaderCellDef class="header-label"> Frame Size </mat-header-cell>
          <mat-cell *matCellDef="let element; let i = dataIndex">
            <div class="first-row">{{ element.streamFrameSize }}</div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="streamPacketLossRatio">
          <mat-header-cell *matHeaderCellDef class="header-label">
            Packet loss Ratio
            <div class="sub-label">%</div></mat-header-cell
          >
          <mat-cell *matCellDef="let element; let i = dataIndex">
            <div class="first-row">{{ element.streamPacketLossRatio }}</div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="streamJitterThreshold">
          <mat-header-cell *matHeaderCellDef class="header-label">
            Jitter Threshold
            <div class="sub-label">ms</div></mat-header-cell
          >
          <mat-cell *matCellDef="let element; let i = dataIndex">
            <div class="first-row">{{ element.streamJitterThreshold }}</div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="streamUdpPort">
          <mat-header-cell *matHeaderCellDef class="header-label"> UDP Port </mat-header-cell>
          <mat-cell *matCellDef="let element; let i = dataIndex">
            <div class="first-row">{{ element.streamUdpPort }}</div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="streamAction">
          <mat-header-cell *matHeaderCellDef class="header-label"> Actions </mat-header-cell>
          <mat-cell *matCellDef="let element; let i = dataIndex">
            <button
              mat-button
              [matMenuTriggerFor]="menu"
              (click)="
                checkValidation('actionDisable', element.strmInUse, element, 'tableA');
                checkRemoveActionValid(element, 'tableA')
              "
            >
              <i class="icon mdi mdi-dots-horizontal"></i>
            </button>
            <mat-menu #menu="matMenu">
              <button
                mat-menu-item
                [disabled]="isValidCloneActionA2B"
                (click)="cloneStream(element, 'tableA')"
              >
                <i class="mdi mdi-content-copy"></i><span>Clone</span>
              </button>
              <button
                mat-menu-item
                *ngIf="direction !== 'unidirectional-a2b' && direction !== 'unidirectional-b2a'"
                (click)="copyA2bData(element, i)"
              >
                <i class="mdi mdi-content-copy onewayAColor"></i>
                <span> A <i class="mdi mdi-arrow-right-bold"></i> B</span>
              </button>
              <button
                mat-menu-item
                [disabled]="isValidRemove || isValidRemoveActionA2B"
                (click)="removeStream(element, 'tableA')"
              >
                <i class="mdi mdi-delete"></i><span>Remove</span>
              </button>
              <button
                *ngIf="!element.strmInUse"
                mat-menu-item
                (click)="enableOrDisableStream(element, i, 'tableA')"
              >
                <i class="mdi mdi-power"></i><span>Enable</span>
              </button>
              <button
                *ngIf="element.strmInUse"
                mat-menu-item
                [disabled]="!errorValidationObj.isValidDisableStream || isValidRemoveAction"
                (click)="enableOrDisableStream(element, i, 'tableA')"
              >
                <i class="mdi mdi-power"></i><span>Disable</span>
              </button>
            </mat-menu>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="a2bTableColumns"></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: a2bTableColumns"
          matRipple
          [ngClass]="!row.strmInUse ? 'element-row-disabled' : 'element-row'"
        ></mat-row>
      </mat-table>
    </div>
  </div>

  <div *ngIf="direction !== 'unidirectional-a2b'" class="second-table-container">
    <div class="direction-label">
      B (Source) <i class="mdi mdi-arrow-right-bold onewayBColor"></i> A (Destination)
    </div>
    <div class="mat-elevation-z8">
      <mat-table #table [dataSource]="dataSourceB2A" multiTemplateDataRows="true" class="table">
        <ng-container matColumnDef="streamName">
          <mat-header-cell *matHeaderCellDef class="header-label"> Name </mat-header-cell>
          <mat-cell *matCellDef="let element; let i = dataIndex" class="name-cell">
            <div class="first-row">
              <input
                matInput
                autocomplete="off"
                type="text"
                name="streamName"
                class="width-115"
                [(ngModel)]="element.streamName"
                [ngClass]="{
                  'error-msg': checkValidation('name', element.streamName, element, 'tableB')
                    ?.isValid
                }"
                (ngModelChange)="
                  checkValidation('name', element.streamName, element, 'tableB');
                  onDataChange(element.streamName, i, configMapping.STREAM_NAME, 'tableB')
                "
                [matTooltip]="
                  checkValidation('name', element.streamName, element, 'tableB')?.message
                "
              />
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="streamType">
          <mat-header-cell *matHeaderCellDef class="header-label"> Stream Type </mat-header-cell>
          <mat-cell *matCellDef="let element; let i = dataIndex">
            <div class="first-row">{{ element.streamType }}</div>
            <a class="edit-text" (click)="onChangeStreamType(element, i, 'tableB')">edit</a>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="streamL2IrB2A">
          <mat-header-cell *matHeaderCellDef class="header-label">
            {{ streamRateConvention === 'l1-mbps' ? 'L1' : 'L2' }} IR
            <div>(B <i class="mdi mdi-arrow-right-bold"></i> A)</div>
            <div class="sub-label">Mbps</div></mat-header-cell
          >
          <mat-cell *matCellDef="let element; let i = dataIndex">
            <div class="first-row">
              {{ element.streamL2IrB2A }}
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="streamUdpBwB2A">
          <mat-header-cell *matHeaderCellDef class="header-label">
            UDP BW
            <div>(B <i class="mdi mdi-arrow-right-bold"></i> A)</div>
            <div class="sub-label">Mbps</div></mat-header-cell
          >
          <mat-cell *matCellDef="let element; let i = dataIndex">
            <div class="first-row">
              {{ element.streamUdpBwB2A }}
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="streamFrameSize">
          <mat-header-cell *matHeaderCellDef class="header-label"> Frame Size </mat-header-cell>
          <mat-cell *matCellDef="let element; let i = dataIndex">
            <div class="first-row">{{ element.streamFrameSize }}</div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="streamPacketLossRatio">
          <mat-header-cell *matHeaderCellDef class="header-label">
            Packet loss Ratio
            <div class="sub-label">%</div></mat-header-cell
          >
          <mat-cell *matCellDef="let element; let i = dataIndex">
            <div class="first-row">{{ element.streamPacketLossRatio }}</div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="streamJitterThreshold">
          <mat-header-cell *matHeaderCellDef class="header-label">
            Jitter Threshold
            <div class="sub-label">ms</div></mat-header-cell
          >
          <mat-cell *matCellDef="let element; let i = dataIndex">
            <div class="first-row">{{ element.streamJitterThreshold }}</div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="streamUdpPort">
          <mat-header-cell *matHeaderCellDef class="header-label"> UDP Port </mat-header-cell>
          <mat-cell *matCellDef="let element; let i = dataIndex">
            <div class="first-row">{{ element.streamUdpPort }}</div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="streamAction">
          <mat-header-cell *matHeaderCellDef class="header-label"> Actions </mat-header-cell>
          <mat-cell *matCellDef="let element; let i = dataIndex">
            <button
              mat-button
              [matMenuTriggerFor]="menu"
              (click)="
                checkValidation('actionDisable', element.strmInUse, element, 'tableB');
                checkRemoveActionValid(element, 'tableB')
              "
            >
              <i class="icon mdi mdi-dots-horizontal"></i>
            </button>
            <mat-menu #menu="matMenu">
              <button
                mat-menu-item
                [disabled]="isValidCloneActionB2A"
                (click)="cloneStream(element, 'tableB')"
              >
                <i class="mdi mdi-content-copy"></i><span>Clone</span>
              </button>
              <button
                mat-menu-item
                [disabled]="isValidRemove || isValidRemoveActionB2A"
                (click)="removeStream(element, 'tableB')"
              >
                <i class="mdi mdi-delete"></i><span>Remove</span>
              </button>
              <button
                *ngIf="!element.strmInUse"
                mat-menu-item
                (click)="enableOrDisableStream(element, i, 'tableB')"
              >
                <i class="mdi mdi-power"></i><span>Enable</span>
              </button>
              <button
                *ngIf="element.strmInUse"
                mat-menu-item
                [disabled]="!errorValidationObj.isValidDisableStream || isValidRemoveAction"
                (click)="enableOrDisableStream(element, i, 'tableB')"
              >
                <i class="mdi mdi-power"></i><span>Disable</span>
              </button>
            </mat-menu>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="b2aTableColumns"></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: b2aTableColumns"
          matRipple
          [ngClass]="!row.strmInUse ? 'element-row-disabled' : 'element-row'"
        ></mat-row>
      </mat-table>
    </div>
  </div>
  <div class="aggregate-container">
    <p class="aggregate-header">Aggregate</p>
    <div class="aggregate-direction-container">
      <table class="table-aggrigate">
        <tr class="row-direction">
          <td class="empty-td"></td>
          <td><b>IR</b></td>
          <td><b>BW</b></td>
        </tr>
        <tr class="row-direction" *ngIf="direction !== 'unidirectional-b2a'">
          <td>A <i class="mdi mdi-arrow-right-bold onewayAColor"></i> B</td>
          <td>{{ totalIrA2B }}</td>
          <td>{{ totalBwA2B }}</td>
        </tr>
        <tr class="row-direction" *ngIf="direction !== 'unidirectional-a2b'">
          <td>B <i class="mdi mdi-arrow-right-bold onewayBColor"></i> A</td>
          <td>{{ totalIrB2A }}</td>
          <td>{{ totalBwB2A }}</td>
        </tr>
      </table>
    </div>
  </div>
</div>
